import React from 'react';
import { FuelSkeleton } from '@frete.com/fuel-react';

interface SkeletonEllipseProps {
  width?: string;
  height?: string;
}

function SkeletonEllipse({
  width = '50px',
  height = '50px',
}: SkeletonEllipseProps) {
  return (
    <div data-testid="skeleton-ellipse">
      <FuelSkeleton
        shape="circle"
        size="custom"
        width={width}
        height={height}
      />
    </div>
  );
}

export default SkeletonEllipse;
